// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configurations
const currentUrl = window.location.href;
const isProd =
  process.env.NODE_ENV === 'production' && !currentUrl.includes('test');

const firebaseConfig = isProd
  ? {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY_PROD,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PROD,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_PROD,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PROD,
      messagingSenderId:
        process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PROD,
      appId: process.env.REACT_APP_FIREBASE_APP_ID_PROD,
    }
  : {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY_DEV,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_DEV,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_DEV,
      appId: process.env.REACT_APP_FIREBASE_APP_ID_DEV,
    };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
